import { useSelector } from 'react-redux';
import { isCampaignTemplateSet } from '@/components/CampaignCreator/helpers';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useHasCampaignAnyTemplates = (): boolean => {
    const { campaign } = useSelector(getCampainCreatorStore);
    return campaign?.CampaignTemplates?.findIndex((template): boolean => isCampaignTemplateSet(template)) > -1;
};
